// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cp-a";
export var fulfillmentFormRail = "_cp-9";
export var headerTitleRow = "_cp-c";
export var orderDetailsWrapper = "_cp-7";
export var orderLinkTrigger = "_cp-2";
export var paymentInformationGrid = "_cp-h";
export var paymentSummaryColumn = "_cp-i";
export var shipmentContainer = "_cp-b";
export var shipmentDetailsMainPane = "_cp-8";
export var shipmentNavigationCard = "_cp-5";
export var shipmentNavigationRail = "_cp-3";
export var shipmentNavigationRailHeader = "_cp-4";
export var shipmentSummaryFact = "_cp-e";
export var shipmentSummaryGrid = "_cp-d";
export var shipmentSummaryMetadataRow = "_cp-f";
export var shipmentSummaryTags = "_cp-g";
export var shipmentWorkspace = "_cp-0";
export var shipmentWorkspaceContent = "_cp-6";
export var shipmentWorkspaceHeader = "_cp-1";